import React, { createContext, useEffect, useState } from 'react';
import { Toaster, toast } from 'react-hot-toast'; 
import isArray from "lodash/isArray"; 
import "../styles/GlobalToast.css"
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
export const Global_Toast = createContext();

const GlobalToast = ({ children }) => {
    const [toastType,setToastType]=useState("");
    let lastToastMessage = '';
    const Notify_Toast = (type, message) => {
        setToastType(type)
        if (typeof message === 'object' && message !== null) {
            if (message && isArray(Object.keys(message))) {
                Object.keys(message).forEach((key) => {
                    Notify_Toast("error", `${key}: ${message[key]}`);
                });
            }
            return ;
        }
        if (!message || message === lastToastMessage) return; 
        lastToastMessage = message;

        if (type && toast[type]) {
            toast[type](message);
        } else {
            toast.error('Invalid toast type');
        }
        setTimeout(() => {
            lastToastMessage = '';
        }, 2500);
    };


    return (
        <Global_Toast.Provider value={{ Notify_Toast }}>
            {children}
            {/* Toaster should only be here in the context */}
            <Toaster position="top-right" toastOptions={{
                limit: 1, 
                duration: 2000, 
                className: `toaster-card_ ${toastType}`,
                icon:toastType==='error'?<CancelIcon className='toast-error-icon'/>:<CheckCircleIcon className='toast-success-icon'/>
            }} />
        </Global_Toast.Provider>
    );
};

export default GlobalToast;


